// Professional translations - English and Spanish
export const translations = {
  en: {
    // Header Navigation
    nav: {
      services: 'Services',
      method: 'Method',
      contact: 'Contact',
      consultation: 'Consultation'
    },
    
    // Hero Section
    hero: {
      label: 'Critical Intervention',
      headline1: 'Your Reputation',
      headline2: 'Is POWER',
      subheadline: 'JUPITER operates at the intersection of legal, digital and narrative control.',
      cta: 'Request Immediate Consultation',
      responseTime: 'Response within 2 hours'
    },
    
    // Reputational Risk Section
    risk: {
      label: 'Threat Landscape',
      title1: 'Reputational',
      title2: 'attacks operate',
      title3: 'at scale',
      description: 'In interconnected digital systems, coordinated attacks can permanently damage credibility within hours. Without immediate intervention, damage compounds exponentially.',
      scenariosLabel: 'High-Risk Scenarios',
      scenarios: [
        'Coordinated defamation campaigns across platforms',
        'Search engine visibility of harmful content',
        'AI-generated misinformation at scale',
        'Anonymous threat actors targeting reputation',
        'Crisis escalation in real-time digital environments'
      ]
    },
    
    // Operational Framework
    framework: {
      label: 'Operational Framework',
      title1: 'We operate across',
      title2: 'vectors of exposure',
      vectors: [
        {
          title: 'Legal Containment',
          description: 'Coordinated legal action to neutralize defamation and enforce accountability'
        },
        {
          title: 'Digital Intervention',
          description: 'Direct engagement with platforms, search systems, and information networks'
        },
        {
          title: 'Narrative Control',
          description: 'Strategic repositioning of information flow and visibility architecture'
        },
        {
          title: 'Information Suppression',
          description: 'Targeted removal and de-indexing of harmful content across ecosystems'
        }
      ],
      note: 'Coordinated multi-vector response for maximum containment velocity'
    },
    
    // Capability Proof
    capability: {
      label: 'Proven Capability',
      title: 'Measurable Intervention',
      subtitle: 'JUPITER operates with documented outcomes in critical scenarios',
      metrics: [
        {
          value: '+700',
          label: 'Harmful links removed',
          detail: 'Across search engines and content networks'
        },
        {
          value: '24/7',
          label: 'Active monitoring',
          detail: 'Real-time threat detection and response'
        },
        {
          value: 'Multi-platform',
          label: 'Intervention capability',
          detail: 'Google, X, Meta, AI systems, news networks'
        },
        {
          value: 'Global',
          label: 'Crisis containment',
          detail: 'Active operations in high-risk environments'
        }
      ],
      note: 'All interventions are conducted with absolute operational discretion. Case documentation available under NDA for qualified engagements.'
    },
    
    // JUPITER Method
    method: {
      label: 'Strategic Framework',
      title: 'The JUPITER Method',
      steps: [
        {
          number: '01',
          title: 'Threat Assessment',
          description: 'Comprehensive analysis of the reputational threat, source identification, and impact mapping'
        },
        {
          number: '02',
          title: 'Strategic Response',
          description: 'Design and execution of a coordinated legal and digital strategy'
        },
        {
          number: '03',
          title: 'Information Control',
          description: 'Strategic visibility management and repositioning of verified information'
        },
        {
          number: '04',
          title: 'Ongoing Protection',
          description: 'Continuous monitoring and defense protocols'
        }
      ]
    },
    
    // Why JUPITER
    why: {
      label: 'Our Principles',
      title1: 'Why',
      title2: 'JUPITER',
      principles: [
        'Absolute operational confidentiality',
        'Integrated legal and intelligence strategy',
        'International investigative capabilities',
        'Rapid-response crisis frameworks',
        'Strategic reputation reconstruction'
      ]
    },
    
    // When Section (Escalation Model)
    when: {
      title1: 'When Strategic',
      title2: 'Intervention Is Required',
      escalationLabel: 'Escalation Scenarios',
      stages: [
        {
          stage: 'Visibility',
          description: 'False or harmful narratives reach indexed visibility'
        },
        {
          stage: 'Distortion',
          description: 'Narratives begin to distort perception'
        },
        {
          stage: 'Amplification',
          description: 'Digital ecosystems amplify misinformation'
        },
        {
          stage: 'Exposure',
          description: 'Reputational exposure becomes material'
        },
        {
          stage: 'Damage',
          description: 'Targeted attacks escalate and consolidate'
        }
      ],
      note: 'JUPITER intervenes at any stage to halt progression, neutralize exposure, and restore control'
    },
    
    // Contact Section
    contact: {
      label: 'Confidential',
      title1: 'Request',
      title2: 'Confidential',
      title3: 'Consultation',
      description: 'Early strategic intervention significantly improves the ability to contain reputational damage.',
      confidentiality: 'All consultations are strictly confidential.',
      form: {
        name: 'Name',
        email: 'Email',
        organization: 'Organization',
        message: 'Brief Description of the Situation',
        encryption: 'All communications are encrypted and handled with discretion',
        submit: 'Submit Confidential Request',
        submitting: 'Submitting...',
        submitted: 'Request Submitted',
        error: 'Request could not be processed. Please try again.',
        success: 'Request received. Our team will respond within 24 hours.'
      }
    },
    
    // Footer
    footer: {
      description: 'Strategic reputation defense and digital crisis response for executives, organizations, and high-profile individuals.',
      navigation: 'Navigation',
      legal: 'Legal',
      links: {
        services: 'Services',
        method: 'Method',
        consultation: 'Confidential Consultation',
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
        confidentiality: 'Confidentiality'
      },
      copyright: '© 2025 JUPITER. All rights reserved.',
      guarantee: 'Absolute Confidentiality Guaranteed'
    },
    
    // Cookie Banner
    cookie: {
      message: 'We use cookies to ensure you get the best experience on our website.',
      decline: 'Decline',
      accept: 'Accept'
    }
  },
  
  es: {
    // Header Navigation
    nav: {
      services: 'Capacidades',
      method: 'Método',
      contact: 'Contacto',
      consultation: 'Consulta'
    },
    
    // Hero Section
    hero: {
      label: 'Intervención Crítica',
      headline1: 'Su Reputación',
      headline2: 'Es PODER',
      subheadline: 'JUPITER opera entre control legal, digital y narrativo.',
      cta: 'Consulta Inmediata',
      responseTime: 'Respuesta en 2 horas'
    },
    
    // Reputational Risk Section
    risk: {
      label: 'Amenazas Digitales',
      title1: 'Ataques reputacionales',
      title2: 'operan a escala',
      title3: 'exponencial',
      description: 'En sistemas digitales interconectados, ataques coordinados destruyen credibilidad en horas. Sin intervención inmediata, el daño se multiplica.',
      scenariosLabel: 'Escenarios Críticos',
      scenarios: [
        'Campañas de difamación coordinadas multiplataforma',
        'Contenido perjudicial en resultados de búsqueda',
        'Desinformación generada por IA a escala masiva',
        'Actores anónimos atacando reputación sistemáticamente',
        'Crisis escalando en tiempo real'
      ]
    },
    
    // Operational Framework
    framework: {
      label: 'Marco Operacional',
      title1: 'Operamos en múltiples',
      title2: 'vectores de exposición',
      vectors: [
        {
          title: 'Contención Legal',
          description: 'Acción legal para neutralizar difamación y exigir responsabilidad'
        },
        {
          title: 'Intervención Digital',
          description: 'Compromiso directo con plataformas, buscadores y redes de información'
        },
        {
          title: 'Control Narrativo',
          description: 'Reposicionamiento estratégico del flujo informativo y arquitectura de visibilidad'
        },
        {
          title: 'Supresión Informativa',
          description: 'Eliminación dirigida y desindexación de contenido dañino en ecosistemas digitales'
        }
      ],
      note: 'Respuesta multi-vector para máxima velocidad de contención'
    },
    
    // Capability Proof
    capability: {
      label: 'Capacidad Verificable',
      title: 'Intervención Medible',
      subtitle: 'JUPITER opera con resultados documentados en escenarios críticos',
      metrics: [
        {
          value: '+700',
          label: 'Enlaces eliminados',
          detail: 'En motores de búsqueda y redes de contenido'
        },
        {
          value: '24/7',
          label: 'Monitoreo activo',
          detail: 'Detección y respuesta de amenazas en tiempo real'
        },
        {
          value: 'Multi-plataforma',
          label: 'Capacidad de intervención',
          detail: 'Google, X, Meta, sistemas IA, medios digitales'
        },
        {
          value: 'Global',
          label: 'Contención de crisis',
          detail: 'Operaciones activas en entornos de alto riesgo'
        }
      ],
      note: 'Todas las intervenciones operan bajo discreción absoluta. Documentación de casos bajo NDA para compromisos verificados.'
    },
    
    // JUPITER Method
    method: {
      label: 'Sistema Estratégico',
      title: 'Método JUPITER',
      steps: [
        {
          number: '01',
          title: 'Evaluación de Amenaza',
          description: 'Análisis de amenaza reputacional, identificación de origen y mapeo de impacto'
        },
        {
          number: '02',
          title: 'Respuesta Estratégica',
          description: 'Diseño y ejecución de estrategia legal y digital coordinada'
        },
        {
          number: '03',
          title: 'Control Informativo',
          description: 'Gestión estratégica de visibilidad y reposicionamiento de información verificada'
        },
        {
          number: '04',
          title: 'Protección Continua',
          description: 'Monitoreo permanente y protocolos de defensa activos'
        }
      ]
    },
    
    // Why JUPITER
    why: {
      label: 'Principios',
      title1: 'Por Qué',
      title2: 'JUPITER',
      principles: [
        'Confidencialidad operativa absoluta',
        'Estrategia legal e inteligencia integrada',
        'Capacidad investigativa internacional',
        'Marcos de respuesta rápida ante crisis',
        'Reconstrucción estratégica reputacional'
      ]
    },
    
    // When Section (Escalation Model)
    when: {
      title1: 'Cuándo Intervenir',
      title2: 'Estratégicamente',
      escalationLabel: 'Modelo de Escalada',
      stages: [
        {
          stage: 'Visibilidad',
          description: 'Narrativas falsas alcanzan visibilidad indexada'
        },
        {
          stage: 'Distorsión',
          description: 'Narrativas distorsionan percepción pública'
        },
        {
          stage: 'Amplificación',
          description: 'Ecosistemas digitales amplifican desinformación'
        },
        {
          stage: 'Exposición',
          description: 'Exposición reputacional genera impacto material'
        },
        {
          stage: 'Daño',
          description: 'Ataques coordinados escalan y consolidan'
        }
      ],
      note: 'JUPITER interviene en cualquier etapa para detener progresión, neutralizar exposición y restaurar control'
    },
    
    // Contact Section
    contact: {
      label: 'Confidencial',
      title1: 'Solicitar',
      title2: 'Consulta',
      title3: 'Confidencial',
      description: 'Intervención estratégica temprana maximiza capacidad de contención ante daño reputacional.',
      confidentiality: 'Todas las consultas son estrictamente confidenciales.',
      form: {
        name: 'Nombre',
        email: 'Email',
        organization: 'Organización',
        message: 'Descripción de la Situación',
        encryption: 'Comunicaciones encriptadas bajo protocolo de discreción',
        submit: 'Enviar Solicitud',
        submitting: 'Enviando...',
        submitted: 'Solicitud Recibida',
        error: 'Error al procesar solicitud. Intente nuevamente.',
        success: 'Solicitud recibida. Respuesta en 24 horas.'
      }
    },
    
    // Footer
    footer: {
      description: 'Defensa estratégica reputacional y respuesta a crisis digitales para ejecutivos, organizaciones e individuos de alto perfil.',
      navigation: 'Navegación',
      legal: 'Legal',
      links: {
        services: 'Capacidades',
        method: 'Método',
        consultation: 'Consulta Confidencial',
        privacy: 'Privacidad',
        terms: 'Términos',
        confidentiality: 'Confidencialidad'
      },
      copyright: '© 2025 JUPITER. Derechos reservados.',
      guarantee: 'Confidencialidad Absoluta Garantizada'
    },
    
    // Cookie Banner
    cookie: {
      message: 'Utilizamos cookies para optimizar experiencia en el sitio.',
      decline: 'Rechazar',
      accept: 'Aceptar'
    }
  }
};
